// extracted by mini-css-extract-plugin
module.exports = {"DateParagraph":"NotificationsDropdown_DateParagraph__3RYdP","IconDiv":"NotificationsDropdown_IconDiv__2lA2z","TextDiv":"NotificationsDropdown_TextDiv__1CWub"};